// src/data/mangoData.js
export const mangoCategories = [
    {
        id: 1,
        name: "Himshagor",
        description: "Sweet and aromatic, perfect for desserts",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.17_2_mwrltz.jpg",
        origin: "Rajshahi",
        variants: [
            { weight: "10kg", price: 1200 },
            { weight: "20kg", price: 2200 },
            { weight: "25kg", price: 2700 }
        ]
    },
    {
        id: 2,
        name: "Amrapali",
        description: "Juicy and fiberless, rich mango flavor",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.17_tnku5z.jpg",
        origin: "Chapainawabganj",
        variants: [
            { weight: "10kg", price: 1000 },
            { weight: "20kg", price: 1900 },
            { weight: "25kg", price: 2300 }
        ]
    },
    {
        id: 3,
        name: "Fazli",
        description: "Large size, sweet and fibrous texture",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812607/WhatsApp_Image_2026-06-18_at_17.37.17_3_a2ekwk.jpg",
        origin: "Rajshahi",
        variants: [
            { weight: "10kg", price: 1100 },
            { weight: "20kg", price: 2000 },
            { weight: "25kg", price: 2500 }
        ]
    },
    {
        id: 4,
        name: "Lengra",
        description: "Famous for its unique sweet taste and aroma",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.16_ihm83r.jpg",
        origin: "Rajshahi",
        variants: [
            { weight: "10kg", price: 1300 },
            { weight: "20kg", price: 2400 },
            { weight: "25kg", price: 2900 }
        ]
    }
];

export const mangoHeroSlides = [
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.17_tnku5z.jpg",
        headline: "🍋 Sweet Summer Mangoes!",
        subheadline: "Fresh, Juicy & Directly from the Farm",
        primaryBtn: "Order Now",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.16_2_m5pq41.jpg",
        headline: "🥭 Premium Quality Mangoes",
        subheadline: "Himshagor, Amrapali, Fazli & More",
        primaryBtn: "Explore Mangoes",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.18_ceut15.jpg",
        headline: "🎁 Bulk Order Available!",
        subheadline: "Perfect for Gifts, Events & Family",
        primaryBtn: "Order in Bulk",
        category: "All"
    }
];